const $main_slider_node = $(".js-slider-main"),
    $line_node = $(".js-slider-line");
let autoplay = 8000;

if($main_slider_node.length){

    let main_slider = $main_slider_node.on("initialized.owl.carousel", function(el) {
        addProgress(el, $line_node);
    }).owlCarousel({
        loop:true,
        margin:0,
        dots:false,
        nav: true,
        autoplay: true,
        autoplayTimeout: autoplay,
        items: 1,
        smartSpeed: 1000,
        navContainer: ".nav-wrap",
        navText: ["<svg><use href='#arrow-left'></use></svg>",
            "<svg><use href='#arrow-right'></use></svg>"],
    }).on("changed.owl.carousel", function() {

        main_slider.trigger("stop.owl.autoplay");
        main_slider.trigger("play.owl.autoplay");

        changeProgress();
    });
}

function addProgress(el, line){

    const $total_node = $(".js-slider-total");
    let total =  el.item.count;

    if(total < 10){
        total = "0" + total;
    }

    $total_node.text(total);

    let time = (autoplay / 1000) + 0.25;

    line.css({"animation-duration": time+"s"});
    showProgress($line_node);
}

function changeProgress(){

    setTimeout(function(){
        const $current_node = $(".js-slider-current");
        let current = $main_slider_node.find(".owl-item.active").find(".item").data("index");

        if(current < 10){
            current = "0" + current;
        }

        $current_node.text(current);
    },0);

    showProgress($line_node);
}

function showProgress($node){

    $node.removeClass("active");

    setTimeout(function(){
        $node.addClass("active");
    },0);
}
